<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <form class="form-horizontal">
              <fieldset>
                <legend>{{ $t('homework.actionForm') }}</legend>
                <action-form-component v-model="model" :validate="errors">
                  <template v-slot:button-action>
                    <ts-button
                      class="mr-2"
                      @click.prevent="$router.push({ name: 'homework' })"
                      >{{ $t('cancel') }}</ts-button
                    >
                    <ts-button
                      outline
                      color="primary"
                      class="mr-2"
                      :waiting="waiting_new"
                      :disabled="isUploading"
                      @click.prevent="onSaveAddNew"
                      >{{ $t('save_add_new') }}</ts-button
                    >
                    <ts-button
                      color="primary"
                      :waiting="waiting"
                      :disabled="isUploading"
                      @click.prevent="onSave"
                      >{{ $t('save') }}</ts-button
                    >
                  </template>
                </action-form-component>
              </fieldset>
            </form>
          </div>
          <div class="col-md-6">
            <form class="form-horizontal">
              <fieldset>
                <legend>{{ $t('homework.attachmentFile') }}</legend>
                <homework-attach-file
                  v-model="model"
                  @upload-status="onUploadStatus"
                />
                <br />
                <training-tool-attachFile
                  v-model="model"
                  @upload-status="onUploadStatus"
                />
              </fieldset>
            </form>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>

    <!-- Duplicate homework modal -->
    <a-modal
      v-model="showDuplicateModal"
      :title="$t('homework.duplicateTitle') || 'Homework Already Exists'"
      :ok-text="$t('homework.goToEdit') || 'Edit Existing'"
      :cancel-text="$t('cancel') || 'Cancel'"
      :z-index="1020"
      @ok="goToExisting"
      @cancel="showDuplicateModal = false"
    >
      <p>
        {{
          $t('homework.duplicateMessage') ||
            'A homework for this class, subject and date already exists. Would you like to edit the existing one instead?'
        }}
      </p>
    </a-modal>
  </div>
</template>

<script>
import ActionFormComponent from './component/action-form'
import HomeworkAttachFile from './component/homework-attach-file'
import TrainingToolAttachFile from './component/training-tool-attach-file'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'TeacherHomeworkCreate',
  components: {
    ActionFormComponent,
    HomeworkAttachFile,
    TrainingToolAttachFile
  },
  data() {
    return {
      waiting: false,
      waiting_new: false,
      isUploading: false,
      uploadingCount: 0,
      showDuplicateModal: false,
      existingHomeworkId: null,
      errors: new Errors(),
      model: {
        homework_date: moment(),
        class_id: '',
        subject_id: '',
        remarks: '',
        submission_end_date: moment().add(7, 'Day'),
        reference_url: [],
        attach_file_list: []
        // NOTE: teacher_id is NOT here — the backend sets it from auth()->user()->object_user_id
      }
    }
  },
  methods: {
    onUploadStatus(uploading) {
      if (uploading) {
        this.uploadingCount++
      } else {
        this.uploadingCount = Math.max(0, this.uploadingCount - 1)
      }
      this.isUploading = this.uploadingCount > 0
    },
    onSave() {
      if (this.isUploading) {
        this.$toasted.warning(
          this.$t('homework.waitForUpload') ||
            'Please wait for files to finish uploading.'
        )
        return
      }
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('eschool/teacherHomework/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'homework' })
        })
        .catch(error => {
          this.handleStoreError(error)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      if (this.isUploading) {
        this.$toasted.warning(
          this.$t('homework.waitForUpload') ||
            'Please wait for files to finish uploading.'
        )
        return
      }
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('eschool/teacherHomework/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.handleStoreError(error)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    handleStoreError(error) {
      if (error.existing_id) {
        this.existingHomeworkId = error.existing_id
        this.showDuplicateModal = true
      } else {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
    },
    goToExisting() {
      this.showDuplicateModal = false
      if (this.existingHomeworkId) {
        this.$store
          .dispatch('eschool/teacherHomework/find', this.existingHomeworkId)
          .then(() => {
            this.$router.push({
              name: 'homework-edit',
              params: { id: this.existingHomeworkId }
            })
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    clearInput() {
      this.model.homework_date = moment()
      this.model.class_id = ''
      this.model.subject_id = ''
      this.model.remarks = ''
      this.model.submission_end_date = moment().add(7, 'Day')
      this.model.reference_url = []
      this.model.attach_file_list = []
      this.uploadingCount = 0
      this.isUploading = false
      this.$children[1].clearHomeworkAttachFile()
      this.$children[2].clearTrainingAttachFile()
    }
  }
}
</script>
